import React from 'react';
export const CopyRight = () => {
    return (
        <p className="mt-5 mb-3 text-muted" style={{ color: '#fff' }}>
            {' '}
            &copy;2020-Consisty System Pvt.Ltd
        </p>
    );
};
